import { render, staticRenderFns } from "./ClientSetting.vue?vue&type=template&id=690cdedd&scoped=true"
import script from "./ClientSetting.vue?vue&type=script&lang=js"
export * from "./ClientSetting.vue?vue&type=script&lang=js"
import style0 from "./ClientSetting.vue?vue&type=style&index=0&id=690cdedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690cdedd",
  null
  
)

export default component.exports